"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_top__up__dark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "63ac999a-8056-4d88-8858-56113927a26e",
    "data-name": "top-up-hi",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "5c3666c6-879e-4629-b23d-e91ffa0adce8",
    x1: 48.09,
    y1: 45.09,
    x2: 143.91,
    y2: 140.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f6f6f6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "03178276-4f3a-4340-9914-ed9f319a7a54",
    x1: 96.5,
    y1: 162.5,
    x2: 96.5,
    y2: 162.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#f6f6f6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "4ee0f345-b3f1-496b-aa46-2e2cdecb16c8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.5,166.5v.92c-4.89-1.75-13.8-2.92-24-2.92s-19.11,1.17-24,2.92v-.92h-4v4c0,3.31,12.54,6,28,6s28-2.69,28-6v-4Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "3473fa3a-6cab-4b95-81e6-a7df92be9a48"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 68.5,
    cy: 166.5,
    rx: 28,
    ry: 6,
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "0cb4ad63-76cf-4ed0-858e-fcf9e5b0f99c",
    x1: 60.16,
    y1: 152.25,
    x2: 85.78,
    y2: 177.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "63720b62-9466-4fa3-9b3e-34448ec7b2e3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100.5,158.5v.92c-4.89-1.75-13.8-2.92-24-2.92s-19.11,1.17-24,2.92v-.92h-4v4c0,3.31,12.54,6,28,6s28-2.69,28-6v-4Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "0246586e-9955-4273-b434-104af1392719"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 76.5,
    cy: 158.5,
    rx: 28,
    ry: 6,
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "084f2d6f-8ff6-450e-af29-3c41e12fb420",
    x1: 63.09,
    y1: 144.97,
    x2: 90.88,
    y2: 172.76,
    xlinkHref: "#0cb4ad63-76cf-4ed0-858e-fcf9e5b0f99c"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "52a5cc63-b14d-4d0c-9264-0431806f799a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.5,150.5v.92c-4.89-1.75-13.8-2.92-24-2.92s-19.11,1.17-24,2.92v-.92h-4v4c0,3.31,12.54,6,28,6s28-2.69,28-6v-4Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "84aaed5a-08a8-4501-95ea-48d3457ff67f",
    x1: 57.91,
    y1: 136.16,
    x2: 83.69,
    y2: 161.94,
    xlinkHref: "#0cb4ad63-76cf-4ed0-858e-fcf9e5b0f99c"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "f341849c-e9e9-46ac-9371-8a90beeb3f3d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.5,142.5v.92c-4.89-1.75-13.8-2.92-24-2.92s-19.11,1.17-24,2.92v-.92h-4v4c0,3.31,12.54,6,28,6s28-2.69,28-6v-4Z",
    fill: "none"
  }))), /*#__PURE__*/React.createElement("title", null, "top-up-hi-dark"), /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 16,
    width: 80,
    height: 160,
    rx: 8,
    ry: 8,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128,174H64a8,8,0,0,1-8-8v2a8,8,0,0,0,8,8h64a8,8,0,0,0,8-8v-2A8,8,0,0,1,128,174Z",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 32,
    width: 72,
    height: 122,
    rx: 2,
    ry: 2,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 24,
    width: 16,
    height: 2,
    rx: 0.71,
    ry: 0.71,
    fill: "#4a4d4e"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 24,
    width: 2,
    height: 2,
    rx: 0.71,
    ry: 0.71,
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "2c8bd59e-8208-4950-a411-d22bbbda0b23",
    "data-name": "Bounding Box",
    width: 192,
    height: 192,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 32,
    width: 72,
    height: 122,
    rx: 2,
    ry: 2,
    opacity: 0.5,
    fill: "url(#5c3666c6-879e-4629-b23d-e91ffa0adce8)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.24
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130,33a1,1,0,0,1,1,1V152a1,1,0,0,1-1,1H62a1,1,0,0,1-1-1V34a1,1,0,0,1,1-1h68m0-1H62a2,2,0,0,0-2,2V152a2,2,0,0,0,2,2h68a2,2,0,0,0,2-2V34a2,2,0,0,0-2-2Z",
    fill: "#333"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "eb752a2e-fbf3-434c-aace-e5b6cb2d4159",
    "data-name": "Bounding Box",
    width: 192,
    height: 192,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.5,162.5",
    stroke: "#666",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    fill: "url(#03178276-4f3a-4340-9914-ed9f319a7a54)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.5,166.5v.92c-4.89-1.75-13.8-2.92-24-2.92s-19.11,1.17-24,2.92v-.92h-4v4c0,3.31,12.54,6,28,6s28-2.69,28-6v-4Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.5,166.5v.92c-4.89-1.75-13.8-2.92-24-2.92s-19.11,1.17-24,2.92v-.92h-4v4c0,3.31,12.54,6,28,6s28-2.69,28-6v-4Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.5,166.5v.92c-4.89-1.75-13.8-2.92-24-2.92s-19.11,1.17-24,2.92v-.92h-4v4c0,3.31,12.54,6,28,6s28-2.69,28-6v-4Z",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#4ee0f345-b3f1-496b-aa46-2e2cdecb16c8)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("line", {
    x1: 44.5,
    y1: 168.5,
    x2: 44.5,
    y2: 174.5,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 52.5,
    y1: 168.5,
    x2: 52.5,
    y2: 176.5,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 60.5,
    y1: 168.5,
    x2: 60.5,
    y2: 176.5,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 68.5,
    y1: 168.5,
    x2: 68.5,
    y2: 176.5,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 76.5,
    y1: 168.5,
    x2: 76.5,
    y2: 176.5,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 84.5,
    y1: 168.5,
    x2: 84.5,
    y2: 176.5,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 92.5,
    y1: 166.5,
    x2: 92.5,
    y2: 174.5,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }))), /*#__PURE__*/React.createElement("ellipse", {
    cx: 68.5,
    cy: 166.5,
    rx: 28,
    ry: 6,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#3473fa3a-6cab-4b95-81e6-a7df92be9a48)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.5,166.5c0-3.12-11.1-5.68-25.3-6l-22.41,3.08L57.17,172c3.47.33,7.3.51,11.33.51C84,172.5,96.5,169.81,96.5,166.5Z",
    opacity: 0.2,
    fill: "url(#0cb4ad63-76cf-4ed0-858e-fcf9e5b0f99c)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M100.5,158.5v.92c-4.89-1.75-13.8-2.92-24-2.92s-19.11,1.17-24,2.92v-.92h-4v4c0,3.31,12.54,6,28,6s28-2.69,28-6v-4Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.5,158.5v.92c-4.89-1.75-13.8-2.92-24-2.92s-19.11,1.17-24,2.92v-.92h-4v4c0,3.31,12.54,6,28,6s28-2.69,28-6v-4Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.5,158.5v.92c-4.89-1.75-13.8-2.92-24-2.92s-19.11,1.17-24,2.92v-.92h-4v4c0,3.31,12.54,6,28,6s28-2.69,28-6v-4Z",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#63720b62-9466-4fa3-9b3e-34448ec7b2e3)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("line", {
    x1: 52.5,
    y1: 160.5,
    x2: 52.5,
    y2: 166.5,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 60.5,
    y1: 160.5,
    x2: 60.5,
    y2: 168.5,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 68.5,
    y1: 160.5,
    x2: 68.5,
    y2: 168.5,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 76.5,
    y1: 160.5,
    x2: 76.5,
    y2: 168.5,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 84.5,
    y1: 160.5,
    x2: 84.5,
    y2: 168.5,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 92.5,
    y1: 160.5,
    x2: 92.5,
    y2: 168.5,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 100.5,
    y1: 158.5,
    x2: 100.5,
    y2: 166.5,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }))), /*#__PURE__*/React.createElement("ellipse", {
    cx: 76.5,
    cy: 158.5,
    rx: 28,
    ry: 6,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#0246586e-9955-4273-b434-104af1392719)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.83,159.24l1.26,1.26c3.83,2.33,14.21,4,26.41,4,15.46,0,28-2.69,28-6,0-2.15-5.3-4-13.25-5.1Z",
    opacity: 0.2,
    fill: "url(#084f2d6f-8ff6-450e-af29-3c41e12fb420)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M90.5,150.5v.92c-4.89-1.75-13.8-2.92-24-2.92s-19.11,1.17-24,2.92v-.92h-4v4c0,3.31,12.54,6,28,6s28-2.69,28-6v-4Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.5,150.5v.92c-4.89-1.75-13.8-2.92-24-2.92s-19.11,1.17-24,2.92v-.92h-4v4c0,3.31,12.54,6,28,6s28-2.69,28-6v-4Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.5,150.5v.92c-4.89-1.75-13.8-2.92-24-2.92s-19.11,1.17-24,2.92v-.92h-4v4c0,3.31,12.54,6,28,6s28-2.69,28-6v-4Z",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#52a5cc63-b14d-4d0c-9264-0431806f799a)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("line", {
    x1: 42.5,
    y1: 152.5,
    x2: 42.5,
    y2: 158.5,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 50.5,
    y1: 152.5,
    x2: 50.5,
    y2: 160.5,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 58.5,
    y1: 152.5,
    x2: 58.5,
    y2: 160.5,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 66.5,
    y1: 152.5,
    x2: 66.5,
    y2: 160.5,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 74.5,
    y1: 152.5,
    x2: 74.5,
    y2: 160.5,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 82.5,
    y1: 152.5,
    x2: 82.5,
    y2: 160.5,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 90.5,
    y1: 150.5,
    x2: 90.5,
    y2: 158.5,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }))), /*#__PURE__*/React.createElement("ellipse", {
    cx: 66.5,
    cy: 150.5,
    rx: 28,
    ry: 6,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.71,144.51l-21,2.9L55.26,156c3.44.32,7.24.5,11.24.5h.6c2.84,0,6.11-.15,9.74-.42,8.39-.71,14.78-2.27,16.9-4.18l.67-.92a1.38,1.38,0,0,0,.09-.47,1.34,1.34,0,0,0,0-.28l-1.92-1.92C88.6,146.15,79,144.61,67.71,144.51Z",
    opacity: 0.2,
    fill: "url(#84aaed5a-08a8-4501-95ea-48d3457ff67f)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.5,142.5v.92c-4.89-1.75-13.8-2.92-24-2.92s-19.11,1.17-24,2.92v-.92h-4v4c0,3.31,12.54,6,28,6s28-2.69,28-6v-4Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.5,142.5v.92c-4.89-1.75-13.8-2.92-24-2.92s-19.11,1.17-24,2.92v-.92h-4v4c0,3.31,12.54,6,28,6s28-2.69,28-6v-4Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.5,142.5v.92c-4.89-1.75-13.8-2.92-24-2.92s-19.11,1.17-24,2.92v-.92h-4v4c0,3.31,12.54,6,28,6s28-2.69,28-6v-4Z",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f341849c-e9e9-46ac-9371-8a90beeb3f3d)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("line", {
    x1: 50.5,
    y1: 144.5,
    x2: 50.5,
    y2: 150.5,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 58.5,
    y1: 144.5,
    x2: 58.5,
    y2: 152.5,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 66.5,
    y1: 144.5,
    x2: 66.5,
    y2: 152.5,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 74.5,
    y1: 144.5,
    x2: 74.5,
    y2: 152.5,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 82.5,
    y1: 144.5,
    x2: 82.5,
    y2: 152.5,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 90.5,
    y1: 144.5,
    x2: 90.5,
    y2: 152.5,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 98.5,
    y1: 142.5,
    x2: 98.5,
    y2: 150.5,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }))), /*#__PURE__*/React.createElement("ellipse", {
    cx: 74.5,
    cy: 142.5,
    rx: 28,
    ry: 6,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.83,75.17l-14-14a4,4,0,0,0-5.66,0l-14,14a4,4,0,1,0,5.66,5.66L92,73.66V122a4,4,0,0,0,8,0V73.66l7.17,7.17a4,4,0,0,0,5.66-5.66Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.83,75.17l-14-14a4,4,0,0,0-5.66,0l-14,14a4,4,0,1,0,5.66,5.66L92,73.66V122a4,4,0,0,0,8,0V73.66l7.17,7.17a4,4,0,0,0,5.66-5.66Z",
    fill: "#333",
    opacity: 0.06
  }));
}

var _default = ic_top__up__dark;
exports.default = _default;